export enum AnswerTypeEnum {
    OPEN = 'OPEN',
    UNIQUE_OPTION = ' UNIQUE_OPTION',
    MULTIPLE_OPTION = 'MULTIPLE_OPTION',
    FORMULA = 'FORMULA'
}
